<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">拆 卸</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="10" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Disassemble</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="40" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">装 配</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="25" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Assemble</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">调 节</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="38" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Adjust</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'principle'}, 'toolbar-item']" @click="selectToobar('principle')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">原 理</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="15" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Principles</textPath>
                            </text>
                          </g>
                          <!-- 椭圆  A(rx, ry, xr, laf, sf, x, y)
                          rx: 椭圆X轴半径
                          ry: 椭圆Y轴半径
                          xr: 椭圆旋转角度
                          laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                          sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                          x: 终点X轴坐标
                          y: 终点Y轴坐标 -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap swiper" v-if="toobarActive === 'upper'">
              <div class="arrow-left"></div>
              <swiper ref="mySwiper" :options="swiperOption">
                  <div
                    class="swiper-slide"
                    v-for="(item,index) in upperObj"
                    :key="index"
                    :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                    @click="upperAnimate(item)"
                  >
                    <template v-if="lang == 'cn'">
                        {{ item.text }}
                    </template>
                    <template v-if="lang == 'en'">
                        {{ item.en_text }}
                    </template>
                </div>
              </swiper>
              <!-- 如果需要导航按钮 -->
              <div class="arrow-right"></div>
            </div>
            <div class="app-submenu-wrap swiper" v-if="toobarActive === 'down'">
              <div class="arrow-left"></div>
              <swiper ref="mySwiper2" :options="swiperOption">
                  <div
                    class="swiper-slide"
                      v-for="(item,index) in downObj"
                    :key="index"
                    :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                    @click="downAnimate(item)"
                  >
                      <template v-if="lang == 'cn'">
                          {{ item.text }}
                      </template>
                      <template v-if="lang == 'en'">
                          {{ item.en_text }}
                      </template>
                  </div>
              </swiper>
              <!-- 如果需要导航按钮 -->
              <div class="arrow-right"></div>
            </div>

            <div class="app-submenu-wrap" v-if="toobarActive === 'outer'">
                <div
                  v-for="(item,index) in outerObj"
                  :key="index"
                  :class="[{'active':outerActive === item.id}, 'app-submenu-item']"
                  @click="outerAnimate(item)"
                  :style="{'margin': '4px 8px'}"
                >
                    <template v-if="lang == 'cn'">
                        {{ item.text }}
                    </template>
                    <template v-if="lang == 'en'">
                        {{ item.en_text }}
                    </template>
                </div>
            </div>

            <div class="app-submenu-wrap" v-if="toobarActive === 'principle'">
                <div
                  v-for="(item,index) in principleObj"
                  :key="index"
                  :class="[{'active':principleNumber === item.id}, 'app-submenu-item']"
                  @click="principleAnimate(item)"
                  :style="{'margin': '4px 8px'}"
                >
                    <template v-if="lang == 'cn'">
                        {{ item.text }}
                    </template>
                    <template v-if="lang == 'en'">
                        {{ item.en_text }}
                    </template>
                </div>
            </div>
        </div>

        <div class="product_name">
          <span v-show="lang == 'cn'">{{principleObj[principleNumber].web_text}}</span>
          <span v-show="lang == 'en'">{{principleObj[principleNumber].web_text_en}}</span>
        </div>

        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { TrackballControls } from "three/examples/jsm/controls/TrackballControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'
    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper.js';


    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        components: {
            Loader,
            Nav,
            language,
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载
                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态

                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                is_hidenote:true,


                principleNumber:0,//当前产品序列号

                upperActive:null, //当前选项1下标
                downActive:null, //当前选项2下标
                outerActive:null,//当前选项3下标

                modelanimationList:[], //动画列表
                selectobject: '', //当前选择的选项
                lang: 'cn', // 语言
                upperObj:[], //拆卸选项
                downObj: [], //装配选项
                outerObj: [], //调节选项
                principleObj:[ //原理选项
                  {
                    id: 0,
                    text: '丝杆', //菜单显示
                    en_text: 'Screw Rod', //菜单显示(英文)
                    web_text: '1700mmPLA淋膜_电机內挡_丝杆', //页面显示
                    web_text_en: '1700mmPLA淋膜_电机內挡_Screw Rod', //页面显示
                    hide_name:["dy","d1","d31","d32","d41","d42","d43","d44","d45","d55","d6","d7","d8","d9","d10","d111","d112","j1","j2","j3","x43","x44","TL","xjls","cb1"],
                  },
                  {
                    id: 1,
                    text: '去外挡', //菜单显示
                    en_text: 'Remove External deckle', //菜单显示(英文)
                    web_text: '1700mmPLA淋膜_电机內挡_去外挡', //页面显示
                    web_text_en: '1700mmPLA淋膜_电机內挡_Remove External deckle', //页面显示
                    hide_name:["dy","d1","d31","d32","d41","d42","d43","d44","d45","d55","d6","d7","d8","d9","d10","d111","d112","x43","x44","TL","xjls","cb1"],
                  },
                  {
                    id: 2,
                    text: '导向架', //菜单显示
                    en_text: 'GuideFrame', //菜单显示(英文)
                    web_text: '1700mmPLA淋膜_电机內挡_导向架', //页面显示
                    web_text_en: '1700mmPLA淋膜_电机內挡_GuideFrame', //页面显示
                    hide_name:["1","3","41","42","43","44","45","teshu","51","52","6","7","8","9","10","j1","j2","j3","x43","x44","sy","TL"],
                  },
                ],
                ProductOptions:[ //产品选项
                  { //111111111111111111111111111
                    upperObj:[ //拆卸选项
                      {
                        id: 0,
                        text: '第1步', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        warn: '<p>1.拆卸掉稳流铜片固定块上的固定螺丝；</p>',
                        en_warn: '<p>1.Disassemble the fixed screws on the flow stabilizing copper piece fixing block</p>',
                        hide_name:[],
                        animate_number: 'C1',
                        camera_position:{
                          x:-52,
                          y:-11,
                          z:-16
                        }
                      },
                      {
                        id: 1,
                        text: '第2步', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        warn: '<p>2.用调节螺母将流道铜片从螺母上脱离；</p>',
                        en_warn: '<p>2.Use an adjusting nut to detach the flow channel copper piece from the nut</p>',
                        hide_name:["1"],
                        animate_number: 'C2',
                        camera_position:{
                          x:-50,
                          y:-5,
                          z:-22
                        }
                      },
                      {
                        id: 2,
                        text: '第3步', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        warn: '<p>3.拆掉流道内档铜片固定块；</p>',
                        en_warn: '<p>3.Remove the fixed block of the channel internal deckle copper piece</p>',
                        hide_name:["1"],
                        animate_number: 'C3',
                        camera_position:{
                          x:-41,
                          y:-4,
                          z:-9
                        }
                      },
                      {
                        id: 3,
                        text: '第4步', //菜单显示
                        en_text: 'Step 4', //菜单显示(英文)
                        warn: '<p>4.拆卸大侧板的固定螺丝和定位销；</p>',
                        en_warn: '<p>4.Disassemble the fixed screws and positioning pins of the large side plate</p>',
                        hide_name:["1","51","52"],
                        animate_number: 'C4',
                        camera_position:{
                          x:-64,
                          y:-18,
                          z:-24
                        }
                      },
                      {
                        id: 4,
                        text: '第5步', //菜单显示
                        en_text: 'Step 5', //菜单显示(英文)
                        warn: '<p>5.整体内档机构脱离模体；</p>',
                        en_warn: '<p>5.Detach the entire internal deckle mechanism from the die</p>',
                        hide_name:["1","51","52","3"],
                        animate_number: 'C5',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 5,
                        text: '第6步', //菜单显示
                        en_text: 'Step 6', //菜单显示(英文)
                        warn: '<p>6.拆卸掉外压板固定螺丝；<br/>平稳的将外压板从稳流铜片和流道铜片末端取出；<br/>拆卸掉内压板固定螺丝；<br/>平稳的将内压板从稳流铜片和流道铜片末端取出；<br/>取下最内侧的密封片；</p>',
                        en_warn: '<p>6.Disassemble the fixed screws of the external pressure plate.<br/>Carefully remove the external pressure plate from the end of the  flow stabilizing copper piece and the flow channel copper piece.<br/>Disassemble the fixed screws of the internal pressure plate.<br/>Carefully remove the internal pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Take off the innermost sealing gasket.</p>',
                        hide_name:["1","51","52","3","41","42","43","44","45","teshu"],
                        animate_number: 'C6',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 6,
                        text: '第7步', //菜单显示
                        en_text: 'Step 7', //菜单显示(英文)
                        warn: '<p>7.平稳的取出稳流铜片和流道铜片。</p>',
                        en_warn: '<p>7.Carefully remove the flow stabilizing copper piece and the flow channel copper piece</p>',
                        hide_name:["1","51","52","3","41","42","43","44","45","teshu","6","7","8","9","10"],
                        animate_number: 'C7',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                    ],
                    downObj: [ //装配选项
                      {
                        id: 0,
                        text: '第1步', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        warn: '<p>1.平稳的装入稳流铜片和流道铜片。</p>',
                        en_warn: '<p>1.Carefully Install the flow stabilizing copper piece and the flow channel copper piece</p>',
                        hide_name:["1","51","52","3","41","42","43","44","45","teshu","6","7","8","9","10"],
                        animate_number: 'z1',
                        camera_position:{
                          x:-57,
                          y:-8,
                          z:-8
                        }
                      },
                      {
                        id: 1,
                        text: '第2步', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        warn: '<p>2.装上最内侧的密封片；<br/>平稳的将内压板从稳流铜片和流道铜片末端装上；<br/>装上内压板固定螺丝；<br/>平稳的将外压板从稳流铜片和流道铜片末端装上；<br/>装上外压板固定螺丝；</p>',
                        en_warn: '<p>2.Install the innermost sealing gasket.<br/>Carefully Install the internal pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Install the fixed screws of the internal pressure plate.<br/>Carefully Install the external pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Install the fixed screws of the external pressure plate.</p>',
                        hide_name:["1","51","52","3","41","42","43","44","45","teshu"],
                        animate_number: 'z2',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 2,
                        text: '第3步', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        warn: '<p>3.整体内档机构装到模体上；</p>',
                        en_warn: '<p>3.The entire internal deckle mechanism is installed on the die</p>',
                        hide_name:["1","51","52","3"],
                        animate_number: 'z3',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 3,
                        text: '第4步', //菜单显示
                        en_text: 'Step 4', //菜单显示(英文)
                        warn: '<p>4.装上大侧板的固定螺丝和定位销；</p>',
                        en_warn: '<p>4.Install the fixed screws and positioning pins of the large side plate</p>',
                        hide_name:["1","51","52"],
                        animate_number: 'z4',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 4,
                        text: '第5步', //菜单显示
                        en_text: 'Step 5', //菜单显示(英文)
                        warn: '<p>5.装上流道内档铜片固定块；</p>',
                        en_warn: '<p>5.Install the fixed block of the channel internal deckle copper piece</p>',
                        hide_name:["1"],
                        animate_number: 'z5',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 5,
                        text: '第6步', //菜单显示
                        en_text: 'Step 6', //菜单显示(英文)
                        warn: '<p>6.用调节螺母将流道铜片从螺母上装入；</p>',
                        en_warn: '<p>6.Use an adjusting nut to install the flow channel copper piece from the nut</p>',
                        hide_name:["1"],
                        animate_number: 'z6',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 6,
                        text: '第7步', //菜单显示
                        en_text: 'Step 7', //菜单显示(英文)
                        warn: '<p>7.装上稳流铜片固定块上的固定螺丝；</p>',
                        en_warn: '<p>7.Install the fixed screws on the flow stabilizing copper piece fixing block</p>',
                        animate_number: 'z7',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                    ],
                    outerObj: [ //调节选项
                      {
                        id: 0,
                        text: '调节一', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        // warn: '<p>1.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>1</p>',
                        hide_name:["x43","x44"],
                        transparent_name:["GA","GB"],
                        animate_number: '产品调节1a',
                        camera_position:{
                          x:-43,
                          y:-10,
                          z:20
                        }
                      },
                      {
                        id: 1,
                        text: '调节二', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        // warn: '<p>2.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>2</p>',
                        hide_name:["x43","x44"],
                        transparent_name:["GA","GB"],
                        animate_number: '产品调节1b',
                        camera_position:{
                          x:-43,
                          y:-10,
                          z:20
                        }
                      },
                      {
                        id: 2,
                        text: '调节三', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        // warn: '<p>3.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>3</p>',
                        hide_name:["43","44"],
                        show_name:["x43","x44"],
                        transparent_name:["GA","GB"],
                        animate_number: '产品调节2',
                        camera_position:{
                          x:-43,
                          y:-10,
                          z:20
                        }
                      },
                    ],
                  },
                  { //222222222222222222222222222
                    upperObj:[ //拆卸选项
                      {
                        id: 0,
                        text: '第1步', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        warn: '<p>1.取下内档驱动电机</p>',
                        en_warn: '<p>1.Remove the internal deckle drive motor</p>',
                        hide_name:[],
                        animate_number: '电机动',
                        camera_position:{
                          x:-74,
                          y:-12,
                          z:-23
                        }
                      },
                      {
                        id: 1,
                        text: '第2步', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        warn: '<p>2.拆卸掉稳流铜片固定块上的固定螺丝；</p>',
                        en_warn: '<p>2.Disassemble the fixed screws on the flow stabilizing copper piece fixing block</p>',
                        hide_name:["j1","j2"],
                        animate_number: 'C1',
                        camera_position:{
                          x:-52,
                          y:-11,
                          z:-16
                        }
                      },
                      {
                        id: 2,
                        text: '第3步', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        warn: '<p>3.用调节螺母将流道铜片从螺母上脱离；</p>',
                        en_warn: '<p>3.Use an adjusting nut to detach the flow channel copper piece from the nut</p>',
                        hide_name:["1","j1","j2"],
                        animate_number: 'C2',
                        camera_position:{
                          x:-50,
                          y:-5,
                          z:-22
                        }
                      },
                      {
                        id: 3,
                        text: '第4步', //菜单显示
                        en_text: 'Step 4', //菜单显示(英文)
                        warn: '<p>4.拆掉流道内档铜片固定块；</p>',
                        en_warn: '<p>4.Remove the fixed block of the channel internal deckle copper piece</p>',
                        hide_name:["1","j1","j2"],
                        animate_number: 'C3',
                        camera_position:{
                          x:-41,
                          y:-4,
                          z:-9
                        }
                      },
                      {
                        id: 4,
                        text: '第5步', //菜单显示
                        en_text: 'Step 5', //菜单显示(英文)
                        warn: '<p>5.拆卸大侧板的固定螺丝和定位销；</p>',
                        en_warn: '<p>5.Disassemble the fixed screws and positioning pins of the large side plate</p>',
                        hide_name:["1","51","52","j1","j2"],
                        animate_number: 'C4',
                        camera_position:{
                          x:-64,
                          y:-18,
                          z:-24
                        }
                      },
                      {
                        id: 5,
                        text: '第6步', //菜单显示
                        en_text: 'Step 6', //菜单显示(英文)
                        warn: '<p>6.整体内档机构脱离模体；</p>',
                        en_warn: '<p>6.Detach the entire internal deckle mechanism from the die</p>',
                        hide_name:["1","51","52","3","j1","j2"],
                        animate_number: 'C5',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 6,
                        text: '第7步', //菜单显示
                        en_text: 'Step 7', //菜单显示(英文)
                        warn: '<p>6.拆卸掉外压板固定螺丝；<br/>平稳的将外压板从稳流铜片和流道铜片末端取出；<br/>拆卸掉内压板固定螺丝；<br/>平稳的将内压板从稳流铜片和流道铜片末端取出；<br/>取下最内侧的密封片；</p>',
                        en_warn: '<p>6.Disassemble the fixed screws of the external pressure plate.<br/>Carefully remove the external pressure plate from the end of the  flow stabilizing copper piece and the flow channel copper piece.<br/>Disassemble the fixed screws of the internal pressure plate.<br/>Carefully remove the internal pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Take off the innermost sealing gasket.</p>',
                        hide_name:["1","51","52","3","41","42","43","44","45","teshu","j1","j2"],
                        animate_number: 'C6',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 7,
                        text: '第8步', //菜单显示
                        en_text: 'Step 8', //菜单显示(英文)
                        warn: '<p>8.平稳的取出稳流铜片和流道铜片。</p>',
                        en_warn: '<p>8.Carefully remove the flow stabilizing copper piece and the flow channel copper piece</p>',
                        hide_name:["1","3","41","42","43","44","45","teshu","6","7","8","9","10","51","52","j1","j2"],
                        animate_number: 'C7',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                    ],
                    downObj: [ //装配选项
                      {
                        id: 0,
                        text: '第1步', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        warn: '<p>1.平稳的装入稳流铜片和流道铜片。</p>',
                        en_warn: '<p>1.Carefully Install the flow stabilizing copper piece and the flow channel copper piece</p>',
                        hide_name:["1","3","41","42","43","44","45","teshu","6","7","8","9","10","51","52","j1","j2"],
                        animate_number: 'z1',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 1,
                        text: '第2步', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        warn: '<p>2.装上最内侧的密封片；<br/>平稳的将内压板从稳流铜片和流道铜片末端装上；<br/>装上内压板固定螺丝；<br/>平稳的将外压板从稳流铜片和流道铜片末端装上；<br/>装上外压板固定螺丝；</p>',
                        en_warn: '<p>2.Install the innermost sealing gasket.<br/>Carefully Install the internal pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Install the fixed screws of the internal pressure plate.<br/>Carefully Install the external pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Install the fixed screws of the external pressure plate.</p>',
                        hide_name:["1","51","52","3","41","42","43","44","45","teshu","j1","j2"],
                        animate_number: 'z2',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 2,
                        text: '第3步', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        warn: '<p>3.整体内档机构装到模体上；</p>',
                        en_warn: '<p>3.The entire internal deckle mechanism is installed on the die</p>',
                        hide_name:["1","51","52","3","j1","j2"],
                        animate_number: 'z3',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 3,
                        text: '第4步', //菜单显示
                        en_text: 'Step 4', //菜单显示(英文)
                        warn: '<p>4.装上大侧板的固定螺丝和定位销；</p>',
                        en_warn: '<p>4.Install the fixed screws and positioning pins of the large side plate</p>',
                        hide_name:["1","51","52","j1","j2"],
                        animate_number: 'z4',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 4,
                        text: '第5步', //菜单显示
                        en_text: 'Step 5', //菜单显示(英文)
                        warn: '<p>5.装上流道内档铜片固定块；</p>',
                        en_warn: '<p>5.Install the fixed block of the channel internal deckle copper piece</p>',
                        hide_name:["1","j1","j2"],
                        animate_number: 'z5',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 5,
                        text: '第6步', //菜单显示
                        en_text: 'Step 6', //菜单显示(英文)
                        warn: '<p>6.用调节螺母将流道铜片从螺母上装入；</p>',
                        en_warn: '<p>6.Use an adjusting nut to install the flow channel copper piece from the nut</p>',
                        hide_name:["1","j1","j2"],
                        animate_number: 'z6',
                        camera_position:{
                          x:-46,
                          y:-6,
                          z:-8
                        }
                      },
                      {
                        id: 6,
                        text: '第7步', //菜单显示
                        en_text: 'Step 7', //菜单显示(英文)
                        warn: '<p>7.装上稳流铜片固定块上的固定螺丝；</p>',
                        en_warn: '<p>7.Install the fixed screws on the flow stabilizing copper piece fixing block</p>',
                        hide_name:["j1","j2"],
                        animate_number: 'z7',
                        camera_position:{
                          x:-64,
                          y:-18,
                          z:-24
                        }
                      },
                      {
                        id: 7,
                        text: '第8步', //菜单显示
                        en_text: 'Step 8', //菜单显示(英文)
                        warn: '<p>8.装上内档驱动电机；</p>',
                        en_warn: '<p>8.Install the internal deckle drive motor</p>',
                        hide_name:[],
                        animate_number: '装电动机',
                        camera_position:{
                          x:-57,
                          y:-8,
                          z:-8
                        }
                      },
                    ],
                    outerObj: [ //调节选项
                      {
                        id: 0,
                        text: '调节一', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        // warn: '<p>1.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>1</p>',
                        hide_name:["x43","x44"],
                        transparent_name:["GA","GB"],
                        animate_number: '产品调节1b',
                        camera_position:{
                          x:-43,
                          y:-10,
                          z:20
                        }
                      },
                      {
                        id: 1,
                        text: '调节二', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        // warn: '<p>2.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>2</p>',
                        hide_name:["x43","x44"],
                        transparent_name:["GA","GB"],
                        animate_number: '产品调节1b',
                        camera_position:{
                          x:-43,
                          y:-10,
                          z:20
                        }
                      },
                      {
                        id: 2,
                        text: '调节三', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        // warn: '<p>3.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>3</p>',
                        hide_name:["43","44"],
                        show_name:["x43","x44"],
                        transparent_name:["GA","GB"],
                        animate_number: '产品调节2',
                        camera_position:{
                          x:-43,
                          y:-10,
                          z:20
                        }
                      },
                    ],
                  },
                  { //333333333333333333333333333
                    upperObj:[ //拆卸选项
                      {
                        id: 0,
                        text: '第一步', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        warn: '<p>1.拆卸掉稳流铜片固定块上的固定螺丝；</p>',
                        en_warn: '<p>1.Disassemble the fixed screws on the flow stabilizing copper piece fixing block</p>',
                        animate_number: 'dc1',
                        camera_position:{
                          x:50,
                          y:-8,
                          z:15
                        }
                      },
                      {
                        id: 1,
                        text: '第二步', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        warn: '<p>2.用调节螺母将流道铜片从螺母上脱离；</p>',
                        en_warn: '<p>2.Use an adjusting nut to detach the flow channel copper piece from the nut</p>',
                        hide_name:["d1"],
                        animate_number: 'dc2',
                        camera_position:{
                          x:50,
                          y:-3,
                          z:-15
                        }
                      },
                      {
                        id: 2,
                        text: '第三步', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        warn: '<p>3.拆掉流道内档铜片固定块；</p>',
                        en_warn: '<p>3.Remove the fixed block of the channel internal deckle copper piece</p>',
                        hide_name:["d1"],
                        animate_number: 'dc3',
                        camera_position:{
                          x:50,
                          y:-3,
                          z:15
                        }
                      },
                      {
                        id: 3,
                        text: '第四步', //菜单显示
                        en_text: 'Step 4', //菜单显示(英文)
                        warn: '<p>4.拆卸大侧板的固定螺丝和定位销；</p>',
                        en_warn: '<p>4.Disassemble the fixed screws and positioning pins of the large side plate</p>',
                        hide_name:["d1","d32","d31"],
                        animate_number: '新加螺丝',
                        camera_position:{
                          x:60,
                          y:-1,
                          z:-8
                        }
                      },
                      {
                        id: 4,
                        text: '第五步', //菜单显示
                        en_text: 'Step 5', //菜单显示(英文)
                        warn: '<p>5.整体内档机构脱离模体；</p>',
                        en_warn: '<p>5.Detach the entire internal deckle mechanism from the die</p>',
                        hide_name:["d1","d31","d32","xjls"],
                        animate_number: 'dc4',
                        camera_position:{
                          x:60,
                          y:-1,
                          z:-8
                        }
                      },
                      {
                        id: 5,
                        text: '第六步', //菜单显示
                        en_text: 'Step 6', //菜单显示(英文)
                        warn: '<p>6.拆卸掉外压板固定螺丝；<br/>平稳的将外压板从稳流铜片和流道铜片末端取出；<br/>拆卸掉内压板固定螺丝；<br/>平稳的将内压板从稳流铜片和流道铜片末端取出；<br/>取下最内侧的密封片；</p>',
                        en_warn: '<p>6.Disassemble the fixed screws of the external pressure plate.<br/>Carefully remove the external pressure plate from the end of the  flow stabilizing copper piece and the flow channel copper piece.<br/>Disassemble the fixed screws of the internal pressure plate.<br/>Carefully remove the internal pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Take off the innermost sealing gasket.</p>',
                        hide_name:["d1","d31","d32","d41","d42","d43","d44","d45","d55","xjls"],
                        animate_number: 'dc5',
                        camera_position:{
                          x:40,
                          y:-5,
                          z:-2
                        }
                      },
                      {
                        id: 6,
                        text: '第七步', //菜单显示
                        en_text: 'Step 7', //菜单显示(英文)
                        warn: '<p>7.平稳的取出稳流铜片和流道铜片。</p>',
                        en_warn: '<p>7.Carefully remove the flow stabilizing copper piece and the flow channel copper piece</p>',
                        hide_name:["d1","d31","d32","d41","d42","d43","d44","d45","d55","d6","d7","d8","d9","d10","xjls"],
                        animate_number: 'dc6',
                        camera_position:{
                          x:60,
                          y:-5,
                          z:-10
                        }
                      },
                    ],
                    downObj: [ //装配选项
                      {
                        id: 0,
                        text: '第一步', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        warn: '<p>1.平稳的装入稳流铜片和流道铜片。</p>',
                        en_warn: '<p>1.Carefully Install the flow stabilizing copper piece and the flow channel copper piece</p>',
                        hide_name:["d1","d31","d32","d41","d42","d43","d44","d45","d55","d6","d7","d8","d9","d10","xjls"],
                        animate_number: 'dz1',
                        camera_position:{
                          x:60,
                          y:-5,
                          z:-10
                        }
                      },
                      {
                        id: 1,
                        text: '第二步', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        warn: '<p>2.装上最内侧的密封片；<br/>平稳的将内压板从稳流铜片和流道铜片末端装上；<br/>装上内压板固定螺丝；<br/>平稳的将外压板从稳流铜片和流道铜片末端装上；<br/>装上外压板固定螺丝；</p>',
                        en_warn: '<p>2.Install the innermost sealing gasket.<br/>Carefully Install the internal pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Install the fixed screws of the internal pressure plate.<br/>Carefully Install the external pressure plate from the end of the flow stabilizing copper piece and the flow channel copper piece.<br/>Install the fixed screws of the external pressure plate.</p>',
                        hide_name:["d1","d31","d32","d41","d42","d43","d44","d45","d55","xjls"],
                        animate_number: 'dz2',
                        camera_position:{
                          x:40,
                          y:-5,
                          z:-2
                        }
                      },
                      {
                        id: 2,
                        text: '第三步', //菜单显示
                        en_text: 'Step 3', //菜单显示(英文)
                        warn: '<p>3.整体内档机构装到模体上；</p>',
                        en_warn: '<p>3.The entire internal deckle mechanism is installed on the die</p>',
                        hide_name:["d1","d31","d32","xjls"],
                        animate_number: 'dz3',
                        camera_position:{
                          x:60,
                          y:-1,
                          z:-8
                        }
                      },

                      {
                        id: 3,
                        text: '第四步', //菜单显示
                        en_text: 'Step 4', //菜单显示(英文)
                        warn: '<p>4.装上大侧板的固定螺丝和定位销；</p>',
                        en_warn: '<p>4.Install the fixed screws and positioning pins of the large side plate</p>',
                        hide_name:["d1","d31","d32"],
                        animate_number: '新加螺丝2',
                        camera_position:{
                          x:60,
                          y:-1,
                          z:-8
                        }
                      },

                      {
                        id: 4,
                        text: '第五步', //菜单显示
                        en_text: 'Step 5', //菜单显示(英文)
                        warn: '<p>5.装上流道内档铜片固定块；</p>',
                        en_warn: '<p>5.Install the fixed block of the channel internal deckle copper piece</p>',
                        hide_name:["d1"],
                        animate_number: 'dz4',
                        camera_position:{
                          x:50,
                          y:-3,
                          z:15
                        }
                      },
                      {
                        id: 5,
                        text: '第六步', //菜单显示
                        en_text: 'Step 6', //菜单显示(英文)
                        warn: '<p>6.用调节螺母将流道铜片从螺母上装入；</p>',
                        en_warn: '<p>6.Use an adjusting nut to install the flow channel copper piece from the nut</p>',
                        hide_name:["d1"],
                        animate_number: 'dz5',
                        camera_position:{
                          x:50,
                          y:-3,
                          z:-15
                        }
                      },
                      {
                        id: 6,
                        text: '第七步', //菜单显示
                        en_text: 'Step 7', //菜单显示(英文)
                        warn: '<p>7.装上稳流铜片固定块上的固定螺丝；</p>',
                        en_warn: '<p>7.Install the fixed screws on the flow stabilizing copper piece fixing block</p>',
                        animate_number: 'dz6',
                        camera_position:{
                          x:50,
                          y:-8,
                          z:15
                        }
                      },
                    ],
                    outerObj: [ //调节选项
                      {
                        id: 0,
                        text: '调节一', //菜单显示
                        en_text: 'Step 1', //菜单显示(英文)
                        // warn: '<p>1.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>1</p>',
                        transparent_name:["GA","GB"],
                        animate_number: '导调节',
                        camera_position:{
                          x:50,
                          y:-10,
                          z:20
                        }
                      },
                      {
                        id: 1,
                        text: '调节二', //菜单显示
                        en_text: 'Step 2', //菜单显示(英文)
                        // warn: '<p>2.逆时针旋转侧板顶持螺丝，取出顶持侧板、小侧板及密封片</p>',
                        // en_warn: '<p>2</p>',
                        transparent_name:["GA","GB"],
                        animate_number: '导调节2',
                        camera_position:{
                          x:50,
                          y:-10,
                          z:20
                        }
                      },
                    ],
                  },
                ]
            }
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },
          /**
           * @description 相机动画2
           */
          tweenCamera2: function(oldup0, newup0, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldup0.x, // 相机x
              y1: oldup0.y, // 相机y
              z1: oldup0.z, // 相机z
            });
            tween.to({
              x1: newup0.x, // 控制点的中心点x
              y1: newup0.y, // 控制点的中心点y
              z1: newup0.z  // 控制点的中心点z
            }, 1000);
            tween.onUpdate(function (object) {
              let up0 = {
                x:0,
                y:0,
                z:0
              }
              up0.x = object.x1;
              up0.y = object.y1;
              up0.z = object.z1;

              _this.controls.object.up.copy( up0 );

              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;
              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;
              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);

              // _this.renderer.toneMapping =THREE.CineonToneMapping
              // _this.renderer.toneMappingExposure=1.5
          },
          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;
              _this.scene = new THREE.Scene();
          },
          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 0, -80);
            _this.camera.lookAt(_this.scene.position);
          },
          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              // _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls = new TrackballControls(_this.camera, _this.renderer.domElement);

              _this.controls.rotateSpeed = 10;
              _this.controls.staticMoving = true;
              _this.controls.noPan = true;
              console.log(_this.controls);
              console.log(_this.controls.up);

              // const upvector = new THREE.Vector3(0,-1,0);
              // _this.controls.object.up.copy(upvector);
              // _this.controls.enablePan = false;
              // _this.controls.enableDamping = true;
              // _this.controls.dampingFactor = 0.1;
              // _this.controls.maxPolarAngle = Math.PI;
              // _this.controls.minPolarAngle = 0;
              // _this.controls.enablePan = false;
              // _this.controls.enableZoom = true;

              // this.target0 = _this.controls.target.clone();
              // this.position0 = _this.controls.object.position.clone();
              this.up0 = _this.controls.object.up.clone();
              // console.log(this.target0,this.position0,this.up0);
          },
          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/mtndjg/mtndjg.glb", function(gltf) {
                console.log(gltf,'gltf');
                for (let i = 0; i < gltf.animations.length; i++) {
                  console.log(i,gltf.animations[i].name);
                }
                _this.model = gltf.scene;
                _this.modelanimationList = gltf.animations
                // _this.model.scale.set(0.1, 0.1, 0.1);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.animate();
                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })
                _this.initmodel()
                _this.upperObj = _this.ProductOptions[_this.principleNumber].upperObj
                _this.downObj = _this.ProductOptions[_this.principleNumber].downObj
                _this.outerObj = _this.ProductOptions[_this.principleNumber].outerObj

                _this.createlight()
              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },
          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
              // _this.labelRenderer.setSize(_this.containerW, _this.containerH);
          },
          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },
          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
              if(_this.clipAction){ //如果有动画则先停止播放
                _this.clipAction.stop()
              }
              this.initmodel()
              this.attentionStatus = false
            }else{
              _this.toobarActive = '';
              _this.$nextTick(()=>{
                this.toobarActive = e;
              })
              if(e == 'outer'){
                this.attentionStatus = false
              }else{
                this.attentionStatus = true
              }
            }
          },
          //添加光源
          createlight(){
            // 创建一个方形光源
            var rectLight = new THREE.RectAreaLight(0xffffff, 3, 37, 6);
            rectLight.position.set(1.6, -1.2, -5.5); // 设置光源位置
            rectLight.rotation.x = Math.PI * 0.75;

            var rectLight2 = new THREE.RectAreaLight(0xffffff, 5, 40, 3.5);
            rectLight2.position.set(0, -2.7, 2); // 设置光源位置
            rectLight2.rotation.x =  Math.PI * 0.25;

            // var rectLight3 = new THREE.RectAreaLight(0xffffff, 3, 40, 7);
            // rectLight3.position.set(0, 5, 0); // 设置光源位置
            // rectLight3.rotation.x =  Math.PI * -0.5;

            // 添加光源到场景
            this.scene.add(rectLight);
            this.scene.add(rectLight2);
            // this.scene.add(rectLight3);

            // 添加一个辅助网格以可视化光源位置
            // var rectLightHelper = new RectAreaLightHelper(rectLight);
            // var rectLightHelper2 = new RectAreaLightHelper(rectLight2);
            // var rectLightHelper3 = new RectAreaLightHelper(rectLight3);

            // this.scene.add(rectLightHelper);
            // this.scene.add(rectLightHelper2);
            // this.scene.add(rectLightHelper3);
          },
          /**
           * @description 菜单选项1
           * @param {number} e 菜单选项对象
           */
          upperAnimate: function(item) {
            let _this = this;
            this.upperActive = item.id
            this.downActive = null
            this.outerActive = null
            this.attentionStatus = true
            this.selectobject = item
            this.initmodel()

            _this.tweenCamera2(_this.controls.object.up,_this.up0)

            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(item.hide_name){ //隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            for (let i = 0; i < _this.modelanimationList.length; i++) {
              if(_this.modelanimationList[i].name == item.animate_number){
                _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[i]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
              }
            }
            // _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }

          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          downAnimate: function(item) {
            let _this = this;
            this.downActive = item.id
            this.upperActive = null
            this.outerActive = null
            this.attentionStatus = true
            this.selectobject = item
            this.initmodel()

            _this.tweenCamera2(_this.controls.object.up,_this.up0)

            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(item.hide_name){ //隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            for (let i = 0; i < _this.modelanimationList.length; i++) {
              if(_this.modelanimationList[i].name == item.animate_number){
                _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[i]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
              }
            }
            // _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          /**
           * @description 菜单选项3
           * @param {Number} e 菜单选项对象
           */
          outerAnimate: function(item) {
            let _this = this;
            this.outerActive = item.id
            this.upperActive = null
            this.downActive = null
            this.selectobject = item
            this.attentionStatus = true

            this.initmodel()
            _this.tweenCamera2(_this.controls.object.up,_this.up0)

            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(item.hide_name){ //隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(item.show_name){
              _this.ShowHideComponents(item.show_name,true)
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            if(item.transparent_name){
              _this.transparentComponents(item.transparent_name,0.3)
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            for (let i = 0; i < _this.modelanimationList.length; i++) {
              if(_this.modelanimationList[i].name == item.animate_number){
                _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[i]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
              }
            }
            // _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          /**
           * @description 菜单选项4 切换产品
           * @param {Number} e 菜单选项对象
           */
          principleAnimate: function(item) {
            let _this = this;
            this.principleNumber = item.id
            this.upperActive = null
            this.downActive = null
            this.outerActive = null
            this.selectobject = item
            this.attentionStatus = false
            this.initmodel()
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            _this.upperObj = _this.ProductOptions[item.id].upperObj
            _this.downObj = _this.ProductOptions[item.id].downObj
            _this.outerObj = _this.ProductOptions[item.id].outerObj
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                console.log("射线器返回对象", intersects);
              }else{
                console.log('null');
              }
            })
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }
          },
          /**
           * @description 显示所有组件
           */
          showallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              object.visible = true
              if (object.isMesh) {
                object.material.depthWrite = true
                object.material.opacity = 1
              }
            })
          },
          /**
           * @description 隐藏所有组件
           */
          hideallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              if(object.isMesh){
                object.visible = false
              }
            })
          },
          /**
           * @description 透明组件/取消透明
           * @param {array} e 透明名列表
           * @param {number} e （透明度）
           * @param {Boolean} e （0透明）or（1取消透明）
           */
          transparentComponents(objectArray,opcity,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.depthWrite = true // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.depthWrite = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              console.log(objectArray);
              console.log(objectArray.length);
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.depthWrite = false // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                  _this.model.getObjectByName(objectArray[i]).material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.depthWrite = false // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(objectArray.length != 0){
              if(determine){ //显示
                for (let i = 0; i < objectArray.length; i++) {
                  _this.model.getObjectByName(objectArray[i]).visible = true
                }
              }else{ //隐藏
                for (let i = 0; i < objectArray.length; i++) {
                  // console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                  _this.model.getObjectByName(objectArray[i]).visible = false
                }
              }
            }
          },
          //初始化状态
          initmodel(){
            let _this = this
            _this.showallcomponents()
            let hide_obj = _this.principleObj[_this.principleNumber].hide_name
            if(hide_obj){
              _this.ShowHideComponents(hide_obj,false)
            }
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            _this.ShowHideComponents(["j1","j2","j3"],false)
            // _this.transparentComponents(["lg"],0.3)
            // console.log(_this.model.getObjectByName("6"),"6");
            // console.log(_this.model.getObjectByName("8"),"8");
            // console.log(_this.model.getObjectByName("LAN"),"LAN");
            // console.log(_this.model.getObjectByName("LV"),"LV");
            // for (let i = 1; i < 7; i++) {
            //   console.log(_this.model.getObjectByName("HG"+i),"HG"+i);
            // }
            // for (let i = 1; i < 4; i++) {
            //   console.log(_this.model.getObjectByName("HX"+i),"HX"+i);
            // }
          },
        },
        mounted: function () {
          let _this = this;
          _this.initCanvas();
          _this.timer = setInterval(function() {
              if ( !_this.hadLoaded ) {
                  if ( _this.loadprogress < 80 ) {
                      _this.loadprogress += 0.8;
                  } else if ( _this.modelLoaded ) {
                      if ( _this.loadprogress <= 100 ) {
                          _this.loadprogress += 2;
                      } else {
                          _this.hadLoaded = true;
                          clearInterval(_this.timer);
                          _this.timer = null;
                      }
                  }
              }
          }, 20);
          // this.raycasterclick()
          window.addEventListener("resize", _this.onResize, false);
          if(sessionStorage.getItem('language')){
            this.lang = sessionStorage.getItem('language'); // 存入一个值
          }else{
            sessionStorage.setItem('language',this.lang); // 存入一个值
          }

          _this.swiperOption = {
            slidesPerView : 3,
            spaceBetween : 10,
            breakpoints: {
              996: {  //当屏幕宽度大于等于768
                slidesPerView: 5,
                spaceBetween: 20
              },
            },
              // 如果需要前进后退按钮
            navigation: {
              prevEl: '.arrow-left',
              nextEl: '.arrow-right',
            },
            on:{
              init: function(){
                // this.slideTo(0);
              },
              click: function(){
                if(this.clickedIndex-this.activeIndex == this.params.slidesPerView-1){
                  this.slideNext()
                }else if(this.clickedIndex-this.activeIndex == 0){
                  this.slidePrev()
                }
              },
            },
          }

        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },

    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  .product_name{
    position: absolute;
    top: 20vh;
    left: 5.2vw;
    font-size: 20px;
    font-weight: bold;
  }
  .swiper{
    /* border: 1px solid #000; */
    position: absolute;
    width: 54vw;
    height: 50px;
    left: 50%;
    top: 0;
    -webkit-transform: translate(-50%,-150%);
    transform: translate(-50%,-150%);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .swiper-container {
    width: 50vw !important;
  }
  .swiper-slide{
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .app-toolbar .app-submenu-wrap .app-submenu-item{
    margin: 0px 0px;
  }
  .arrow-left{
    /* background-color: #34353a; */
    width: 30px;
    height: 30px;
    border-right: 15px solid #34353a;
    border-left: 15px solid #34353a00;
    border-top: 15px solid #34353a00;
    border-bottom: 15px solid #34353a00;
    cursor: pointer;
  }
  .arrow-right{
    /* background-color: #34353a; */
    width: 30px;
    height: 30px;
    border-left: 15px solid #34353a;
    border-right: 15px solid #34353a00;
    border-top: 15px solid #34353a00;
    border-bottom: 15px solid #34353a00;
    cursor: pointer;
  }
  .swiper-button-disabled{
    opacity: 0.5;
  }
  /* /deep/ .swiper-wrapper{
    justify-content: center;
  } */
  /* .app-submenu-wrap div{
    justify-content: center;
  } */
  @media (max-width:1620px) {
    .swiper{
      width: 56vw !important;
    }
  }
  @media (max-width:996px) {
    .swiper{
      width: 70vw !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mtndjg.vue